import { Component, OnChanges, Output, EventEmitter, Input, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { PHBHPFeaturePackageSOPManagementService } from '../ph-bhp-feature-package-sopmanagement.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { SopDetail } from '../Models';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { StepsVersions } from '../Models/StepsVersions';
import { PhBhpViewSOPComponent } from '../ph-bhp-view-sop/ph-bhp-view-sop.component';
import { Subscription } from 'rxjs';
import { isNullOrUndefined } from 'util';
import { TranslateService } from '@ngx-translate/core';
import { TranslationKeys } from 'ph-bhp-localization';
import { PhBhpUserMenuComponent } from 'src/app/layout/ph-bhp-user-menu/ph-bhp-user-menu.component';
import { UserDataService } from 'src/app/services/userData.service';
import { Router } from '@angular/router';
@Component({
  selector: 'lib-ph-bhp-sop',
  templateUrl: './ph-bhp-sop.component.html',
  styleUrls: ['./ph-bhp-sop.component.css']
})
export class PhBhpSopComponent implements OnChanges, OnDestroy {
  @Output() childData = new EventEmitter();
  @Input() userData: any;
  @Input() isDesktop = true;
  @ViewChild('disclaimerModal') disclaimerModal: TemplateRef<any>;
  @ViewChild('confirmModal') confirmModal: TemplateRef<any>;
  userRole;
  modalRef: BsModalRef;
  userFlag = true;
  deleteSOPID
  searchText: string;
  viewFlag: string = 'all';
  isCollapsed: Array<boolean> = [false];
  sopDetails: Array<SopDetail> = [];
  allSopDetails: Array<SopDetail> = [];
  draftSopDetails: Array<SopDetail> = [];
  publishedSopDetails: Array<SopDetail> = [];
  globalSopDetails: Array<SopDetail> = [];
  countrySopDetails: Array<SopDetail> = [];
  emitVal: any;
  getSopSubscription: Subscription;
  sopDetail: SopDetail = {} as SopDetail;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  noTabScreen: boolean = false;

  fields: any[];
  actionItems: any = [
    // draft buttons
    {
      name: 'LAYOUT_MODULE.VIEW',
      imgSrc: 'assets/ph-bhp-layout/svg/icon-view.svg',
      canShow: (dataItem) => { return dataItem.versionNo == 0 },
      onClick: (dataItem) => { this.draftEditSOP('view', dataItem.detail.sopid, dataItem.versionNo); }
    },
    {
      name: 'EVALUATION.EXPORT_PDF',
      imgSrc: 'assets/ph-bhp-layout/svg/download-icon-blue.svg',
      canShow: (dataItem) => { return dataItem.versionNo == 0 },
      onClick: (dataItem) => { this.downloadVersion(dataItem.detail.sopid, dataItem.versionNo); }
    },
    {
      name: 'CONFIGURE.EDIT',
      imgSrc: 'assets/ph-bhp-layout/svg/icon-edit.svg',
      canShow: (dataItem) => { return dataItem.versionNo == 0 && dataItem.detail?.permissions.includes('edit') },
      onClick: (dataItem) => { this.draftEditSOP('editVersion', dataItem.detail.sopid, dataItem.versionNo); }
    },
    {
      name: 'LAYOUT_MODULE.DELETE',
      imgSrc: 'assets/ph-bhp-layout/svg/icon-delete.svg',
      canShow: (dataItem) => { return dataItem.versionNo == 0 && dataItem.detail?.permissions.includes('delete') },
      onClick: (dataItem) => { this.draftDeleteSOPDraft(dataItem.detail.sopid, dataItem.versionNo); }
    },

    // action buttons
    {
      name: 'LAYOUT_MODULE.VIEW',
      imgSrc: 'assets/ph-bhp-layout/svg/icon-view.svg',
      canShow: (dataItem) => { return dataItem.versionNo != 0 },
      onClick: (dataItem) => { this.viewVersion(dataItem.sopid, dataItem.versionNo); }
    },
    {
      name: 'EVALUATION.EXPORT_PDF',
      imgSrc: 'assets/ph-bhp-layout/svg/download-icon-blue.svg',
      canShow: (dataItem) => { return dataItem.versionNo != 0 },
      onClick: (dataItem) => { this.downloadVersion(dataItem.sopid, dataItem.versionNo); }
    },
    {
      name: 'CONFIGURE.EDIT',
      imgSrc: 'assets/ph-bhp-layout/svg/icon-edit.svg',
      canShow: (dataItem, rowIndex = 0) => { return dataItem.versionNo != 0 && (!this.hasDraft(dataItem) && rowIndex == 0) && dataItem.detail?.permissions.includes('edit') },
      onClick: (dataItem) => { this.editVersion(dataItem.sopid, dataItem.versionNo); }
    },
    {
      name: 'SOP_MANAGEMENT.DUPLICATE',
      imgSrc: 'assets/ph-bhp-layout/svg/icon-copy-blue.png',
      canShow: (dataItem) => { return dataItem.versionNo != 0 && dataItem.detail?.permissions.includes('duplicate') && this.maxVersion(dataItem.sopid) == (dataItem.stepsVersionID || 0) },
      onClick: (dataItem) => { this.duplicateVersion(dataItem.sopid, dataItem.versionNo); }
    },

  ];

  constructor(private service: PHBHPFeaturePackageSOPManagementService,
    public layoutService: PHBHPLayoutPackageService,
    private modalService: BsModalService,
    private translate: TranslateService,
    private userDataService: UserDataService,
    private router: Router
  ) { }

  ngOnInit() {

    this.noTabScreen = !this.router.url.includes('sopEditor');

    this.layoutService.sopManagementInitMobile.subscribe(() => {
      this.userFlag = true;
      this.getSopDetails();
    });
    this.fields = [
      {
        'field': 'versionNo', 'title': 'INSTITUTION_MANAGEMENT.VERSION'
      },
      {
        'field': 'status', 'title': 'INSTITUTION_MANAGEMENT.STATUS'
      },
      {
        'field': 'publishedUser', 'title': 'EVALUATION.USER'
      },
      {
        'field': 'createdDateTimeText', 'title': 'INSTITUTION_MANAGEMENT.DATE_AND_TIME'
      },
      {
        'field': 'comments', 'title': 'SOP_MANAGEMENT.COMMENTS'
      },


    ]
  }
  ngOnChanges() {
    this.getSopDetails();
    this.getSopSubscription = this.service.getSopList.subscribe(() => {
      this.userFlag = true;
      this.getSopDetails();
    });
  }

  ngOnDestroy() {
    this.getSopSubscription.unsubscribe();
  }

  getSopDetails() {
    this.layoutService.showLoader = true;
    if (this.userData && this.userFlag) {
      this.userRole = this.userData.roleName.roleId;
      this.userFlag = false;
      this.service.getSOPDetails(this.userData.userId, this.layoutService.institutionID || 0).subscribe((res: Array<SopDetail>) => {
        window.scrollTo(0, 0);
        res.forEach((sop) => {
          sop.sopInstitutions.sort((a, b) => a.institutionName ? a.institutionName.localeCompare(b.institutionName) : false);
        });
        
        if (this.userRole != 1 && this.userRole != 2) {
          const allowedInstitutionIds = (this.userDataService.institutionsList || []).map(inst => inst.id);

          res.forEach((sop) => {
            sop.sopInstitutions = sop.sopInstitutions?.filter(inst => allowedInstitutionIds.includes(inst.institutionID)
            ) || [];
          });
        }
        
        let that = this;
        this.sopDetails = res.map(item => this.manageGrid(item, that));
        this.allSopDetails = this.sopDetails;
        this.draftSopDetails = this.sopDetails.filter((res) => res.draftStepsJson != '');
        this.publishedSopDetails = this.sopDetails.filter((res) => res.draftStepsJson == '');
        this.globalSopDetails = this.sopDetails.filter((res) => res.type == 'Master' && res.authorType == 'sa');
        this.countrySopDetails = this.sopDetails.filter((res) => res.type == 'Master' && res.authorType == 'ca');
        this.layoutService.showLoader = false;
      });
    } else {
      this.layoutService.showLoader = false;
    }
  }

  changeView(type) {
    this.viewFlag = type;
    this.isCollapsed = [false];
    switch (type) {
      case 'all': this.sopDetails = this.allSopDetails; break;
      case 'draft': this.sopDetails = this.draftSopDetails; break;
      case 'published': this.sopDetails = this.publishedSopDetails; break;
      case 'global': this.sopDetails = this.globalSopDetails; break;
      case 'country': this.sopDetails = this.countrySopDetails; break;
    }
  }

  draftEditSOP(key: any, sopId: number, sopVersionNo: number) {
    if (key === 'view') {
      const initialState = {
        sopId: sopId,
        userData: this.userData
      };
      if (this.isDesktop) {
        this.modalRef = this.modalService.show(PhBhpViewSOPComponent, { initialState, class: 'modal-full w-full' });
      } else {
        this.childData.emit({ key: 'viewVersion', data: initialState });
      }
    } else {
      this.emitVal = { key: key, val: { sopId: sopId, sopVersionNo: sopVersionNo } };
      this.childData.emit(this.emitVal);
    }

    //this.modalRef = this.modalService.show(this.disclaimerModal, Object.assign({}, { class: 'w-420' }));
  }
  draftDeleteSOP(id, createdBy) {
    this.deleteSOPID = id;
    this.modalRef = this.modalService.show(this.confirmModal, Object.assign({}, { class: 'w-420 yes-no-modal' }));
    //if (this.userData.userId == createdBy || this.userRole == 1) {
      //this.deleteSOPID = id;
      //this.modalRef = this.modalService.show(this.confirmModal, Object.assign({}, { class: 'w-420 yes-no-modal' }));
    //} else {
      //this.layoutService.showError(this.layoutService.translateText('SOP_MANAGEMENT.NOT_AUTHORIZED_TO_DELETE_SOP'));
    //}
  }

  DeleteSOP() {

    this.service.deleteSOP(this.deleteSOPID, this.userData.userId).subscribe((res: any) => {
      // if(res.message == "SOP has been deleted successfully" ){
      // this.layoutService.showSuccess(this.layoutService.translateText('SOP_MANAGEMENT.SOP_DELETED_SUCCESSFULLY'));
      this.layoutService.showLoader = true;
      this.service.getSOPDetails(this.userData.userId, this.layoutService.institutionID || 0).subscribe((res: Array<SopDetail>) => {
        window.scrollTo(0, 0);
        this.layoutService.showLoader = false;
        let that = this;
        this.sopDetails = res.map(item => this.manageGrid(item, that));;
        this.allSopDetails = this.sopDetails;
        this.draftSopDetails = this.sopDetails.filter((res) => res.draftStepsJson != '');
        this.publishedSopDetails = this.sopDetails.filter((res) => res.draftStepsJson == '');
        this.globalSopDetails = this.sopDetails.filter((res) => res.type == 'Master' && res.authorType == 'sa');
        this.countrySopDetails = this.sopDetails.filter((res) => res.type == 'Master' && res.authorType == 'ca');
      });
      //}
    })
  }

  draftDeleteSOPDraft(id, deletedBy) {

    this.service.deleteSOPDraft(id, deletedBy).subscribe((res: any) => {
      // if(res.message == "SOP has been deleted successfully" ){
      this.layoutService.showLoader = true;
      this.service.getSOPDetails(this.userData.userId, this.layoutService.institutionID || 0).subscribe((res: Array<SopDetail>) => {
        window.scrollTo(0, 0);
        this.layoutService.showLoader = false;
        let that = this;
        this.sopDetails = res.map(item => this.manageGrid(item, that));
        this.allSopDetails = this.sopDetails;
        this.draftSopDetails = this.sopDetails.filter((res) => res.draftStepsJson != '');
        this.publishedSopDetails = this.sopDetails.filter((res) => res.draftStepsJson == '');
        this.globalSopDetails = this.sopDetails.filter((res) => res.type == 'Master' && res.authorType == 'sa');
        this.countrySopDetails = this.sopDetails.filter((res) => res.type == 'Master' && res.authorType == 'ca');
      });
      //}
    })
  }

  openCollapsed(i, sop: any) {
    var temp = this.isCollapsed[i];
    this.isCollapsed = [false];
    this.isCollapsed[i] = !temp;

    if (sop.draftStepsJson != '' && (!sop.sopStepsVersions[0] || sop.sopStepsVersions[0].versionNo != 0)) {
      sop.sopStepsVersions.unshift();
      sop.sopStepsVersions.splice(0, 0, {
        detail: sop,
        versionNo: 0,
        status: 'SOP_MANAGEMENT.DRAFT',
        comments: sop.draftComments,
        createdDateTime: (sop.updatedDateTime) ? sop.updatedDateTime : sop.createdDateTime,
        publishedUser: sop.draftName

      })
    }

  }
  searchTextChange() {
    this.isCollapsed = [false];
    if (this.searchText == '' || this.searchText == null || this.searchText.length == 0) {
      switch (this.viewFlag) {
        case 'all': this.sopDetails = this.allSopDetails; break;
        case 'draft': this.sopDetails = this.draftSopDetails; break;
        case 'published': this.sopDetails = this.publishedSopDetails; break;
        case 'global': this.sopDetails = this.globalSopDetails; break;
        case 'country': this.sopDetails = this.countrySopDetails; break;
      }
      return;
    }

    var details = [];
    switch (this.viewFlag) {
      case 'all': details = this.allSopDetails; break;
      case 'draft': details = this.draftSopDetails; break;
      case 'published': details = this.publishedSopDetails; break;
      case 'global': this.sopDetails = this.globalSopDetails; break;
      case 'country': this.sopDetails = this.countrySopDetails; break;
    }

    this.sopDetails = details.filter((sop) => {
      var title = this.layoutService.translateText(sop.title);
      var description = this.layoutService.translateText(sop.description);
      return title.toLowerCase().includes(this.searchText.toLowerCase()) || description.toLowerCase().includes(this.searchText.toLowerCase());
    })
  }

  onSearchTextChanged(text: string): void {
    this.searchText = text;
    this.searchTextChange();
  }

  duplicateDraft(sopId) {
    this.emitVal = {
      key: 'duplicate',
      val: {
        sopId: sopId
      }
    }
    this.modalRef = this.modalService.show(this.disclaimerModal, Object.assign({}, { class: 'w-420 yes-no-modal' }));
  }

  duplicateVersion(sopId, sopVersionNo) {
    const roleId = this.userData.roleName.roleId;
    const isMaster = (roleId === 1 || roleId === 2) ? true : false;
    this.emitVal = {
      key: 'duplicateVersion',
      val: {
        sopId: sopId,
        sopVersionNo: sopVersionNo,
        userId: this.userData.userId,
        institutionId: this.layoutService.institutionID,
        isMaster
      }
    }
    this.modalRef = this.modalService.show(this.disclaimerModal, Object.assign({}, { class: 'w-420 yes-no-modal' }));
  }

  duplicateNationVersion(sopId, sopVersionNo) {
    this.emitVal = {
      key: 'duplicateNationVersion',
      val: {
        sopId: sopId,
        sopVersionNo: sopVersionNo,
        userId: this.userData.userId,
        institutionId: this.layoutService.institutionID,
        countryId: this.userData.country
      }
    }
    this.modalRef = this.modalService.show(this.disclaimerModal, Object.assign({}, { class: 'w-420 yes-no-modal' }));
  }

  disclaimer() {
    // disclaimer was accepted, send the previously set event values
    this.childData.emit(this.emitVal);
  }
  newSop(clickUrl) {
    this.service.subStepDisable = false;
    // this.emitVal = { key: 'url', val: clickUrl };
    // this.modalRef = this.modalService.show(this.disclaimerModal, Object.assign({}, { class: 'w-420' }));
    this.createNewSOP(clickUrl);
  }

  createNewSOP(_: string) {
    const roleId = this.userData.roleName.roleId;
    // this.sopDetail.accessType = (roleId === 1) ? 'Global' : 'Country';
    this.sopDetail.type = (roleId === 1 || roleId === 2) ? 'Master' : 'User Created';
    this.sopDetail.sopInstitutions = []
    this.sopDetail.createdBy = this.userData.userId;
    this.layoutService.showLoader = true;
    this.sopDetail.isSOPPuzzle = true
    this.sopDetail.isSubStep = false;
    this.sopDetail.countryID = roleId === 1 ? undefined : this.userData.country;

    this.service.createSOP(JSON.stringify(this.sopDetail)).subscribe((res) => {
      // this.layoutService.showSuccess(this.layoutService.translateText('SOP_MANAGEMENT.SUCCESSFULLY_ADDED_SOP'));
      this.layoutService.showLoader = false;
      this.childData.emit({ key: this.translationKeys.Authorization.Save });

      this.editVersion(res.sopid, 0);
    });
  }

  editVersion(sopId, sopVersionNo) {
    this.emitVal = { key: 'editVersion', val: { sopId: sopId, sopVersionNo: sopVersionNo } };
    this.childData.emit(this.emitVal);
    //this.modalRef = this.modalService.show(this.disclaimerModal, Object.assign({}, { class: 'w-420' }));
  }
  viewVersion(sopId, sopVersionNo) {
    // this.emitVal = { key: 'viewVersion', val: { sopId: sopId, stepsVersionIndex: stepsVersionIndex } }
    // this.childData.emit(this.emitVal);
    var initialState = {
      sopId: sopId,
      sopVersionNo: sopVersionNo,
      userData: this.userData,
      isDownload: false
    }
    if (this.isDesktop) {
      this.modalRef = this.modalService.show(PhBhpViewSOPComponent, { initialState, class: 'modal-full w-full' });
    } else {
      this.childData.emit({ key: 'viewVersion', data: initialState });
    }
    //this.modalRef = this.modalService.show(this.disclaimerModal, Object.assign({}, { class: 'w-420' }));
  }
  downloadVersion(sopId, sopVersionNo) {
    // this.emitVal = { key: 'viewVersion', val: { sopId: sopId, stepsVersionIndex: stepsVersionIndex } }
    // this.childData.emit(this.emitVal);
    var initialState = {
      sopId: sopId,
      sopVersionNo: sopVersionNo,
      userData: this.userData,
      isDownload: true
    }
    if (this.isDesktop) {
      this.modalRef = this.modalService.show(PhBhpViewSOPComponent, { initialState, class: 'modal-full w-full dissapear' });
    } else {
      this.childData.emit({ key: 'viewVersion', data: initialState });
    }
    //this.modalRef = this.modalService.show(this.disclaimerModal, Object.assign({}, { class: 'w-420' }));
  }
  formatDateTime(dateString) {
    const date = this.layoutService.convertUTCDateToLocalDate(new Date(dateString));
    let lang = localStorage.getItem('selectedlanguage');
    lang = (lang ? (lang == 'null' ? 'en' : lang) : 'en');
    if (!this.isDesktop) {
      lang = this.layoutService.translate.currentLang;
    }
    return isNullOrUndefined(date) ? dateString : `${date.toLocaleDateString(lang, { weekday: 'long', month: "long", day: "numeric", year: "numeric" })}, ${this.formatTime(date)}`
  }

  setLocalTime(dateString) {
    const date = this.layoutService.convertUTCDateToLocalDate(new Date(dateString));
    let lang = localStorage.getItem('selectedlanguage');
    lang = (lang ? (lang == 'null' ? 'en' : lang) : 'en');
    if (!this.isDesktop) {
      lang = this.layoutService.translate.currentLang;
    }
    return isNullOrUndefined(date) ? dateString : date.toLocaleDateString(lang, { month: "short", day: "numeric", year: "numeric" })
  }

  formatTime(date: Date) {
    let time;
    // const lang = localStorage.getItem('selectedlanguage');
    // if (lang === 'en') {
    //   const hours = +(date.getHours());
    //   const minutes = +(date.getMinutes());
    //   let meridian = 'AM';

    //   let formatedHour = hours;
    //   if (formatedHour >= 12) {
    //     formatedHour = hours - 12;
    //     meridian = 'PM';
    //   }
    //   if (formatedHour == 0) {
    //     formatedHour = 12;
    //   }

    //   const formatedminutes = (minutes < 10) ? '0' + minutes : minutes;
    //   const formatedFullHour = (formatedHour < 10) ? '0' + formatedHour : formatedHour;

    //   time = `${formatedFullHour}:${formatedminutes} ${meridian}`;
    // } else {
    //   const formatedminutes = (date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes();
    //   const formatedFullHour = (date.getHours() < 10) ? '0' + date.getHours() : date.getHours();
    //   time = `${formatedFullHour}:${formatedminutes}`;
    // }
    const formatedminutes = (date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes();
    const formatedFullHour = (date.getHours() < 10) ? '0' + date.getHours() : date.getHours();
    time = `${formatedFullHour}:${formatedminutes}`;
    return time;
  }

  convertUTCStingToLocalDate(dateTime) {
    return this.formatTime(this.layoutService.convertUTCStingToLocalDate(dateTime));
  }

  hasDraft(sopDetail) {
    return sopDetail.versionNo == 0;
  }

  maxVersion(sopId: number) {
    let detail: SopDetail = this.sopDetails.find(sop => sop.sopid === sopId)
    return Math.max(...detail.sopStepsVersions.map(v => v.versionNo), 0);
  }

  errImg(e: Event) {
    e.target['src'] = 'assets/img/fallback-img-gray.png';
  }

  manageGrid(sop, that) {


    sop.sopStepsVersions.forEach((version, i) => {
      if (i == 0 && version.versionNo != 0) {
        version.status = 'SOP_MANAGEMENT.PUBLISHED'
      } else if (i == 1 && version.versionNo == 0) {
        version.status = 'SOP_MANAGEMENT.PUBLISHED'
      }
      version.detail = Object.assign({}, sop);

      if (version.versionNo != 0) {
        // const date = new Date(version.createdDateTime);
        // const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' } as const;
        // const formattedDate = date.toLocaleString('en-US', options);
        // version.createdDateTimeText = formattedDate.replace(',', ' |');
        const date = this.layoutService.convertUTCDateToLocalDate(new Date(version.createdDateTime));
        let lang = localStorage.getItem('selectedlanguage');
        lang = (lang ? (lang == 'null' ? 'en' : lang) : 'en');
        if (!this.isDesktop) {
          lang = this.layoutService.translate.currentLang;
        }
        version.createdDateTimeText = isNullOrUndefined(date) ? version.createdDateTime : date.toLocaleDateString(lang, { month: "short", day: "numeric", year: "numeric" }) + ' | ' + this.convertUTCStingToLocalDate(version.createdDateTime);
      } else {
        version.createdDateTimeText = '';
      }

    })


    // {{(

    //   (rowIndex == 0 && dataItem.versionNo != 0)?'SOP_MANAGEMENT.PUBLISHED':
    //   (rowIndex == 1 && sopDetail.sopStepsVersions[rowIndex-1].versionNo == 0)?'SOP_MANAGEMENT.PUBLISHED':
    //   (dataItem.versionNo == 0)?'SOP_MANAGEMENT.DRAFT':'') | translate }}


    return sop;
  }

  isDeleteAllowed(sopDetail: any) {
    return sopDetail.permissions.includes('delete_sop') && this.isDesktop;
  }

  getBackgroundColor() {
    var currentUrl = window.location.href;
    if (currentUrl.includes('/sopObserve/sopEditor')) {
      return 'white';
    } else {
      return '#F5F5F5';
    }
  }

  mustShowCampaign() {
    var currentUrl = window.location.href;
    return currentUrl.includes('/sopObserve/sopEditor');
  }
}
